module.exports = __webpack_public_path__ + "media/images/emblems/Bernex-coat_of_arms-d874810c395036391f7e747b4c2ad9d1.svg";